import { render, staticRenderFns } from "./SendersOrMessageTypes.vue?vue&type=template&id=a17fa3fc&"
import script from "./SendersOrMessageTypes.vue?vue&type=script&lang=js&"
export * from "./SendersOrMessageTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports